import { useState } from 'react';
import { Tabs, Card } from 'antd';
import withRoleAccess from '../../hoc/withRoleAccess';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import './Reports.css'
import StudentReport from './StudentReport';
import TeacherReport from './TeacherReport';
import ClassReport from './ClassReport';
import ClassroomReport from './ClassroomReport';

const { TabPane } = Tabs;

const Reports = () => {
  const [activeTab, setActiveTab] = useState('student');

  return (
    <div className="reports-container">
           <Sidebar />
            <Header />
      <Card>
        <Tabs activeKey={activeTab} onChange={setActiveTab} type="card">
          <TabPane tab="Student" key="student">
            <div><StudentReport /></div>
          </TabPane>
          <TabPane tab="Tutor" key="tutor">
            <div><TeacherReport /></div>
          </TabPane>
          <TabPane tab="Class" key="class">
            <div><ClassReport /></div>
          </TabPane>
          <TabPane tab="Classroom" key="classroom">
            <div><ClassroomReport /></div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default withRoleAccess(Reports, ['superadmin']);
